export type AbilityAction = (typeof abilityActions)[number];
export type RawAbilityAction = AbilityAction | 'manage';

export const abilityActions = [
  // CRUD actions
  'create',
  'read',
  'update',
  'delete',
  // import export actions
  'export',
  'import',
  // ONT actions
  'configure',
  'activate',
  'deactivate',
  // Ticket actions
  'comment',
] as const;

export const abilityActionMap: Map<RawAbilityAction, string> = new Map([
  ['create', 'Vytvoriť'],
  ['read', 'Čítať'],
  ['update', 'Upraviť'],
  ['delete', 'Vymazať'],
  ['manage', 'Plný prístup'],
  ['export', 'Exportovať'],
  ['import', 'Importovať'],
  ['configure', 'Konfigurovať'],
  ['activate', 'Aktivovať'],
  ['deactivate', 'Deaktivovať'],
  ['comment', 'Komentovať'],
]);
